module.exports = __webpack_public_path__ + "img/characterAnime23.d67177a8.png";